import { useContext } from 'react';

import { UserSimulationWidgetContext } from '../context/UserSimulationWidgetContext';

export const useSimulationWidgetContext = () => {
  return useContext(UserSimulationWidgetContext);
};
